export default __webpack_public_path__ + "static/media/pp.6a52d3c0.jpg";